<div
  class="wrapper"
  [ngClass]="{
    error: icon === 'error',
    info: icon === 'info',
    warn: icon === 'warning',
    success: icon === 'check_circle'
  }"
  *ngIf="message"
>
  <mat-icon
    aria-hidden="false"
    aria-label="error"
    [ngClass]="{
      'icon-error': icon === 'error',
      'icon-info': icon === 'info',
      'icon-warn': icon === 'warning',
      'icon-success': icon === 'check_circle'
    }"
  >
    {{ icon }}
  </mat-icon>
  <p
    [ngClass]="{
      'error-message': icon === 'error',
      'info-message': icon === 'info',
      'warn-message': icon === 'warning',
      'success-message': icon === 'check_circle'
    }"
  >
    {{ message }}
  </p>
</div>
